export const OWN_PRIZES_FETCH_SUCCEEDED = 'OWN_PRIZES_FETCH_SUCCEEDED'
export const OWN_PRIZES_FETCH_FAILED = 'OWN_PRIZES_FETCH_FAILED'
export const LOAD_OWN_PRIZES = 'LOAD_OWN_PRIZES'
export const PRIZES_FETCH = 'PRIZES_FETCH'
export const PRIZES_FETCH_SUCCEEDED = 'PRIZES_FETCH_SUCCEEDED'
export const PRIZES_FETCH_FAILED = 'PRIZES_FETCH_FAILED'
export const PRIZE_SELECTED = 'PRIZE_SELECTED'
export const BUY_PRIZE = 'BUY_PRIZE'
export const BUY_PRIZE_SUCCEEDED = 'BUY_PRIZE_SUCCEEDED'
export const BUY_PRIZE_FAILED = 'BUY_PRIZE_FAILED'

export const loadPrizes = () =>
  ({ type: PRIZES_FETCH, payload: {} })

export const selectPrize = ({ id, credits, image_url, name, amount }) =>
  ({ type: PRIZE_SELECTED, payload: { id, credits, image_url, name, amount } })

export const buyPrize = ({ id, credits, image_url, name, amount }) =>
  ({ type: BUY_PRIZE, payload: { id, credits, image_url, name, amount } })

export const buyPrizeSucceeded = ({ transaction_id }, { id, credits, image_url, name, amount }) =>
  ({ type: BUY_PRIZE_SUCCEEDED, payload: { id, transaction_id, credits, image_url, name, amount } })

export const buyPrizeFailed = ({ id, credits, image_url, name, amount }) =>
  ({ type: BUY_PRIZE_FAILED, payload: { id, credits, image_url, name, amount } })

export const prizesFetchSucceeded = prizes =>
  ({ type: PRIZES_FETCH_SUCCEEDED, payload: prizes })

export const prizesFetchFailed = data =>
  ({ type: PRIZES_FETCH_FAILED, payload: data })

export const loadOwnPrizes = () =>
  ({ type: LOAD_OWN_PRIZES, payload: {} })

export const ownPrizesFetchSucceeded = my_prizes =>
  ({ type: OWN_PRIZES_FETCH_SUCCEEDED, payload: my_prizes })

export const ownPrizesFetchFailed = () =>
  ({ type: OWN_PRIZES_FETCH_FAILED, payload: {} })



// WEBPACK FOOTER //
// ./src/actions/prizes.jsx